/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FuelUpMoveResponseMoveResult } from './FuelUpMoveResponseMoveResult';
import {
    FuelUpMoveResponseMoveResultFromJSON,
    FuelUpMoveResponseMoveResultFromJSONTyped,
    FuelUpMoveResponseMoveResultToJSON,
    FuelUpMoveResponseMoveResultToJSONTyped,
} from './FuelUpMoveResponseMoveResult';
import type { FuelUpPrestigeResponse } from './FuelUpPrestigeResponse';
import {
    FuelUpPrestigeResponseFromJSON,
    FuelUpPrestigeResponseFromJSONTyped,
    FuelUpPrestigeResponseToJSON,
    FuelUpPrestigeResponseToJSONTyped,
} from './FuelUpPrestigeResponse';
import type { FuelUpGameStateResponse } from './FuelUpGameStateResponse';
import {
    FuelUpGameStateResponseFromJSON,
    FuelUpGameStateResponseFromJSONTyped,
    FuelUpGameStateResponseToJSON,
    FuelUpGameStateResponseToJSONTyped,
} from './FuelUpGameStateResponse';
import type { FuelUpVaultState } from './FuelUpVaultState';
import {
    FuelUpVaultStateFromJSON,
    FuelUpVaultStateFromJSONTyped,
    FuelUpVaultStateToJSON,
    FuelUpVaultStateToJSONTyped,
} from './FuelUpVaultState';

/**
 * 
 * @export
 * @interface FuelUpMoveResponse
 */
export interface FuelUpMoveResponse {
    /**
     * 
     * @type {boolean}
     * @memberof FuelUpMoveResponse
     */
    success: boolean;
    /**
     * 
     * @type {FuelUpGameStateResponse}
     * @memberof FuelUpMoveResponse
     */
    gameState: FuelUpGameStateResponse;
    /**
     * 
     * @type {FuelUpVaultState}
     * @memberof FuelUpMoveResponse
     */
    vault?: FuelUpVaultState;
    /**
     * 
     * @type {FuelUpPrestigeResponse}
     * @memberof FuelUpMoveResponse
     */
    prestige?: FuelUpPrestigeResponse;
    /**
     * 
     * @type {FuelUpMoveResponseMoveResult}
     * @memberof FuelUpMoveResponse
     */
    moveResult: FuelUpMoveResponseMoveResult;
}

/**
 * Check if a given object implements the FuelUpMoveResponse interface.
 */
export function instanceOfFuelUpMoveResponse(value: object): value is FuelUpMoveResponse {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('gameState' in value) || value['gameState'] === undefined) return false;
    if (!('moveResult' in value) || value['moveResult'] === undefined) return false;
    return true;
}

export function FuelUpMoveResponseFromJSON(json: any): FuelUpMoveResponse {
    return FuelUpMoveResponseFromJSONTyped(json, false);
}

export function FuelUpMoveResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FuelUpMoveResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'gameState': FuelUpGameStateResponseFromJSON(json['gameState']),
        'vault': json['vault'] == null ? undefined : FuelUpVaultStateFromJSON(json['vault']),
        'prestige': json['prestige'] == null ? undefined : FuelUpPrestigeResponseFromJSON(json['prestige']),
        'moveResult': FuelUpMoveResponseMoveResultFromJSON(json['moveResult']),
    };
}

export function FuelUpMoveResponseToJSON(json: any): FuelUpMoveResponse {
    return FuelUpMoveResponseToJSONTyped(json, false);
}

export function FuelUpMoveResponseToJSONTyped(value?: FuelUpMoveResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'gameState': FuelUpGameStateResponseToJSON(value['gameState']),
        'vault': FuelUpVaultStateToJSON(value['vault']),
        'prestige': FuelUpPrestigeResponseToJSON(value['prestige']),
        'moveResult': FuelUpMoveResponseMoveResultToJSON(value['moveResult']),
    };
}

